import { getIntersectionRoot } from '@theme/scroll-container';

class SybilReveal extends HTMLElement {
  #observer;
  #motionQuery;
  #motionController;

  connectedCallback() {
    this.#observer?.disconnect();
    this.#motionController?.abort();
    this.#motionController = new AbortController();
    this.#motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.#motionQuery.addEventListener('change', this.#handleMotionChange, {
      signal: this.#motionController.signal,
    });

    if (this.#motionQuery.matches) {
      this.#reveal();
      return;
    }

    this.#observer = new IntersectionObserver(this.#handleIntersection, {
      root: getIntersectionRoot(),
      threshold: 0.12,
    });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#motionController?.abort();
  }

  #handleIntersection = (entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    this.#reveal();
  };

  #handleMotionChange = (event) => {
    if (event.matches) this.#reveal();
  };

  #reveal = () => {
    this.classList.add('is-visible');
    this.#observer?.unobserve(this);
    this.#observer?.disconnect();
  };
}

if (!customElements.get('sybil-reveal')) {
  customElements.define('sybil-reveal', SybilReveal);
}
